import MX_Constants from '../util/MX_Constants'
import { SHAPE_TYPES } from './types';
import { Rectangle } from './shapes';

function Reference()
{
    Rectangle.call(this,
        {
            type: SHAPE_TYPES.REFERENCE,
            icon:MX_Constants.IMAGE_REFERENCE,
            options:[]
        });

}
Reference.prototype = Object.create(Rectangle.prototype);
Reference.prototype.fromJSON = function(json)
{
    
}
Reference.prototype.toJSON = function()
{
    return null;
}
Reference.prototype.getStep = function(){
    let step = {
      name: this.name,
      uid: this.uid,
      type: this.type,
      parent:this.parentUID
    };
    return step;
}
export default Reference;
